import styled from 'styled-components';

const MainContainer = styled.main`
  position: relative;
  flex: 1;
  padding: 36px 75px;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 44px);
`;

export { MainContainer };
